import axios from '../lib/dm_axios';
import path from '../config/path';
const apiRootPath = path.apiRootPath;

var Controller = {};

Controller.getChallengeClaim = async function(challengeId) {
  try {
    var collectibles = await axios.get(
      apiRootPath + `claims/challenges/${challengeId}`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

Controller.getTokenClaim = async function(challengeId) {
  try {
    var collectibles = await axios.get(
      apiRootPath + `claims/tokens/${challengeId}`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

Controller.claimChallenge = async function(challengeId, shippingInfo) {
  try {
    var collectibles = await axios.post(
      apiRootPath + `claims/challenges/${challengeId}`,
      { shippingInfo }
    );
    return collectibles;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

Controller.claimToken = async function(tokenId, shippingInfo, note) {
  try {
    var collectibles = await axios.post(
      apiRootPath + `claims/tokens/${tokenId}`,
      { shippingInfo, note }
    );
    return collectibles;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export default Controller;
